import { render } from "./DetailHairSchedule.vue?vue&type=template&id=acd6a3f8&scoped=true"
import script from "./DetailHairSchedule.vue?vue&type=script&lang=js"
export * from "./DetailHairSchedule.vue?vue&type=script&lang=js"

import "./DetailHairSchedule.vue?vue&type=style&index=0&id=acd6a3f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-acd6a3f8"

export default script